import React, { useState, useEffect } from 'react';
import { getApiUrl, axiosPost, getDecodedCookie } from '../../helpers/helperApp';
import useLogicForm from '../../hooks/useLogicForm';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import MiDataTable from '../../componentes/ui/MiDataTable';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import swal from 'sweetalert';
import Spinner from 'react-bootstrap/Spinner';
import Cookies from 'universal-cookie';



function References({ agentName, agentId, agentType }) {
    const {
        formularioPrin,
        saveFormularioPrin,
        handleInputForm,
        handleEditRegPrin,
        resetFormPrin,
        handleSubmitPrin
    } = useLogicForm();

    const [estadoForm, setEstadoForm] = useState('new');
    const [references, setReferences] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isSearchingArticle, setIsSearchingArticle] = useState(false);
    const [tableKey, setTableKey] = useState(0);

    // Estados para la búsqueda paginada de referencias del proveedor
    const [refSearchTerm, setRefSearchTerm] = useState('');
    const [supplierRefs, setSupplierRefs] = useState([]);
    const [refPage, setRefPage] = useState(1);
    const [totalRefPages, setTotalRefPages] = useState(1);
    const [isRefLoading, setIsRefLoading] = useState(false);
    const [showRefSuggestions, setShowRefSuggestions] = useState(false);

    // Estados para la búsqueda paginada de artículos
    const [articleSuggestions, setArticleSuggestions] = useState([]);
    const [articlePage, setArticlePage] = useState(1);
    const [totalArticlePages, setTotalArticlePages] = useState(1);
    const [isArticleLoading, setIsArticleLoading] = useState(false);

    // Datos validacion para la API
    const apiKey = () => {
        const cookies = new Cookies();
        const idSesion = getDecodedCookie('sesion');
        const sesion = getDecodedCookie('id');
        const validacion = { "sesion": idSesion, "id": sesion };

        return JSON.stringify(validacion);
    }

    const fetchReferencesForAgent = async (agentId, page, searchTerm = '') => {
        if (!agentId || (isRefLoading && page === 1)) return;
        setIsRefLoading(true);
        try {
            const data = new FormData();
            data.append("validacion", apiKey());
            data.append("supplierId", agentId);
            data.append("page", page);
            data.append("perPage", 25);
            if (searchTerm) data.append("searchTerm", searchTerm);
            const url = `${getApiUrl(window.location.origin)}/articulos/getReferencesFromSupplier`;
            const response = await axiosPost(url, data);
            if (response.data.success) {
                const newRefs = (response.data.data || []).map(item => ({ id: item.cod2, cod: item.cod2, nom: '' }));
                setSupplierRefs(prev => page === 1 ? newRefs : [...prev, ...newRefs]);
                setTotalRefPages(response.data.pagination.totalPages);
                setRefPage(page);
            } else if (page === 1) setSupplierRefs([]);
        } catch (error) { console.error("Error al cargar las referencias del agente:", error); if (page === 1) setSupplierRefs([]); }
        finally { setIsRefLoading(false); }
    };


    const confReferencias = {
        padre: {
            urls: {
                search: 'agentes/referencias/search',
                edit: 'agentes/referencias/edit',
                delete: 'agentes/referencias/delete',
                create: 'agentes/referencias/create'
            },
            tabla: 'ref_uni',
            modelform: {
                id: '',
                idpro: agentId || '',
                refpro: '',
                des: '',
                idart: '',
                nomart: ''
            }
        }
    };

    useEffect(() => {
        saveFormularioPrin(prev => ({ ...prev, idpro: agentId || '' }));
        setEstadoForm("new");
    }, [agentId]);


    useEffect(() => {
        if (!agentId) return;
        if (!refSearchTerm.trim()) {
            setSupplierRefs([]);
            return;
        }
        const handler = setTimeout(() => {
            setSupplierRefs([]);
            fetchReferencesForAgent(agentId, 1, refSearchTerm);
        }, 350);
        return () => clearTimeout(handler);
    }, [refSearchTerm, agentId]);


    useEffect(() => {
        const fetchReferences = async () => {
            if (!agentId) {
                setReferences([]);
                return;
            }
            setLoading(true);
            try {
                const data = new FormData();
                data.append("validacion", apiKey());
                data.append("id", agentId)
                const url = `${getApiUrl(window.location.origin)}/agentes/getSuppliersFromAgent`;
                const response = await axiosPost(url, data);

                const mappedData = (response.data.data || []).map(item => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = item.unidad;
                    const nomartText = tempDiv.textContent || tempDiv.innerText || '';

                    return {
                        id: item.id,
                        idpro: item.idage,
                        refpro: item.cod,
                        des: item.nom,
                        idart: item.iduni,
                        nomart: item.unidad,      // HTML para display
                        nomart_text: nomartText // Texto para edición
                    };
                });

                setReferences(mappedData);

            } catch (error) {
                console.error("Error al cargar las referencias:", error);
                swal("Error", "No se pudieron cargar las referencias desde el servidor.", "error");
                setReferences([]);
            } finally {
                setLoading(false);
            }
        };

        fetchReferences();
    }, [agentId]);

    // Estado para el buscador de artículos
    const [articleSearchTerm, setArticleSearchTerm] = useState('');
    const [showArticleSuggestions, setShowArticleSuggestions] = useState(false);


    const fetchArticles = async (searchTerm, page) => {
        setIsArticleLoading(true);
        try {
            const data = new FormData();
            data.append("validacion", apiKey());
            data.append('searchTerm', searchTerm);
            data.append('page', page);
            data.append('perPage', 25); 

            const url = `${getApiUrl(window.location.origin)}/articulos/getArticlesToSupplier`;
            const response = await axiosPost(url, data);
            if (response.data.success) {
                const newArticles = response.data.data || [];
                // Si es la primera página, reemplaza. Si no, añade.
                setArticleSuggestions(prev => page === 1 ? newArticles : [...prev, ...newArticles]);
                setTotalArticlePages(response.data.pagination.totalPages);
                setArticlePage(page);
            }
        } catch (error) {
            console.error("Error al buscar artículos:", error);           
        } finally {
            setIsArticleLoading(false);
        }
    };

    // Efecto con debounce para buscar artículos
    useEffect(() => {
        if (!isSearchingArticle && !formularioPrin.idart) return;

        const handler = setTimeout(() => {
            if (articleSearchTerm) {
                fetchArticles(articleSearchTerm, 1);
            } else {
                setArticleSuggestions([]); // Limpia si no hay término de búsqueda
            }
        }, 300); 

        return () => {
            clearTimeout(handler); // Limpia el temporizador si el usuario sigue escribiendo
        };
    }, [articleSearchTerm]);

    const handleEdit = (e) => {
     
        const id = typeof e === "object" ? e.target.id : e;        
        const record = references.find(r => parseInt(r.id) === parseInt(id));

        if (record) {
            saveFormularioPrin({
                id: record.id,
                idpro: record.idpro,
                refpro: record.refpro,
                des: record.des,
                idart: record.idart,
                nomart: record.nomart_text
            });
            setArticleSearchTerm(record.nomart_text || '');
            setEstadoForm("edit");
            setIsSearchingArticle(false); // Al editar, no estamos en modo búsqueda aún
            setRefSearchTerm(record.refpro || '');
        }   
    };


    const handleDelete = async (e) => {

        const willDelete = await swal({
            title: "¿Estás seguro?",
            text: "Una vez eliminada, no podrás recuperar esta referencia.",
            icon: "warning",
            buttons: ["Cancelar", "Eliminar"],
            dangerMode: true,
        });

        if (willDelete) {

            try {

                const id = typeof e === "object" ? e.target.id : e;
                const record = references.find(r => r.id === parseInt(id));


                setReferences(references.filter(ref => ref.id !== id));

                swal("Eliminado", "La referencia ha sido eliminada con éxito.", "success");
            } catch (error) {
                console.error("Error al eliminar la referencia:", error);
                swal("Error", "Ocurrió un problema al conectar con el servidor.", "error");
            }
        }
    };

    const handleCancelEdit = () => {
        resetFormPrin(confReferencias.padre.modelform);
        saveFormularioPrin(prev => ({ ...prev, idpro: agentId || '' }));
        setArticleSearchTerm('');
        setEstadoForm("new");
        setIsSearchingArticle(false);
        setRefSearchTerm('');
        setSupplierRefs([]);
        setShowRefSuggestions(false);
    };

    const handleSave = async (e) => {

        if (e && e.preventDefault) e.preventDefault();

        if (formularioPrin.id) { // Estamos editando

            // --- INICIO DE VALIDACIONES ---
            const newRefPro = formularioPrin.refpro.trim();
            if (!newRefPro) {
                swal("Error de validación", "El campo 'Referencia' no puede estar vacío.", "error");
                return;
            }

            // Buscamos si ya existe una referencia con el mismo código para este proveedor
            const duplicate = references.find(ref =>
                ref.id !== formularioPrin.id && // Excluimos la referencia que estamos editando
                ref.refpro.trim().toLowerCase() === newRefPro.toLowerCase()
            );

            if (duplicate) {
                // Si encontramos un duplicado, comprobamos si también coincide el artículo
                if (duplicate.idart === formularioPrin.idart) {
                    swal("Error de validación", "La combinación de esta referencia y artículo ya existe para el proveedor.", "error");
                    return;
                }
                // Si solo coincide la referencia pero no el artículo
                swal("Error de validación", "El código de referencia ya está en uso para otro artículo de este proveedor.", "error");
                return;
            }
            // --- FIN DE VALIDACIONES ---

            try {
                // Mapeamos los datos del formulario al formato que espera el payload del backend
                const payload = {
                    id: formularioPrin.id,
                    iduni: formularioPrin.idart,
                    idage: formularioPrin.idpro,
                    cod: newRefPro, // Usamos la versión sin espacios extra
                    nom: formularioPrin.des
                };

                const data = new FormData();
                data.append('validacion', apiKey());
                data.append('payload', JSON.stringify(payload));

                const url = `${getApiUrl(window.location.origin)}/agentes/updateArticleReference`;
                const response = await axiosPost(url, data);

                if (response.data && response.data.success !== false) {
                    const updatedReferences = references.map(ref => {
                        if (ref.id === formularioPrin.id) {
                            const articleChanged = ref.idart !== formularioPrin.idart;
                            const { nomart } = formularioPrin; // HTML del formulario

                            const tempDiv = document.createElement('div');
                            tempDiv.innerHTML = nomart || '';
                            const nomartText = tempDiv.textContent || tempDiv.innerText || '';

                            return {
                                ...ref,
                                ...formularioPrin,
                                nomart: articleChanged
                                    ? (formularioPrin.idart ? nomart : null) // Si cambia, usa el nuevo HTML
                                    : ref.nomart, // Si no cambia, preserva el HTML original
                                nomart_text: nomartText // El texto extraído del HTML
                            };
                        }
                        return ref;
                    });

                    setReferences(updatedReferences);
                    swal("¡Actualizado!", "La referencia ha sido guardada con éxito.", "success");
                    setTableKey(prevKey => prevKey + 1); // Forzar el remontaje de la tabla
                    handleCancelEdit();
                } else {
                    // Si success es false, muestra el mensaje del backend
                    console.log(response.data.message);
                    swal("Error", response.data.message || "El servidor indicó un problema al guardar la referencia.", "error");
                }
            } catch (error) {
                // Si el error tiene una respuesta del servidor (como un 409)
                if (error.response && error.response.data && error.response.data.message) {
                    // Muestra el mensaje de error específico del backend
                    swal("Error", error.response.data.message, "error");
                } else {
                    console.error("Error al guardar la referencia:", error);
                    swal("Error", "No se pudo conectar con el servidor para guardar los cambios.", "error");
                }
            }
        }
    };

    // Lógica del buscador de artículos
    const handleArticleSearchChange = (e) => {
        const searchTerm = e.target.value;
        setArticleSearchTerm(searchTerm);
        setShowArticleSuggestions(true);
    };

    const handleSelectArticle = (article) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = article.unidad;
        const articleName = tempDiv.textContent || tempDiv.innerText || '';

        setArticleSearchTerm(articleName); // Texto plano para el input
        // Guardamos el HTML original en el estado del formulario
        saveFormularioPrin(prev => ({ ...prev, idart: article.id, nomart: article.unidad }));
        setShowArticleSuggestions(false);
    };

    const handleRefSearchChange = (e) => {
        const value = e.target.value;
        setRefSearchTerm(value);
        saveFormularioPrin(prev => ({ ...prev, refpro: value }));
        if (value.trim()) {
            setShowRefSuggestions(true);
        } else {
            setShowRefSuggestions(false);
            setSupplierRefs([]);
        }
    };

    const handleSelectRef = (ref) => {
        setRefSearchTerm(ref.cod);
        saveFormularioPrin(prev => ({ ...prev, refpro: ref.cod, des: ref.nom }));
        setShowRefSuggestions(false);
    };

    // Definición de columnas para MiDataTable
    const columns = [
        { title: 'Referencia Proveedor', data: 'refpro' },
        { title: 'Descripción', data: 'des' },
        {
            title: 'Artículo Asociado',
            data: 'nomart',
            render: (data, type, row) => {
                if (type === 'display') {
                    // row.idart viene de iduni. Si existe, muestra el HTML de nomart (unidad).
                    return row.idart ? data : '<span class="text-muted fst-italic">No asociado</span>';
                }
                // Para filtrado y ordenación, usa el texto plano.
                return row.nomart_text;
            }
        }
    ];

    return (
        <Container fluid className="mt-4">
            <h2 className="mb-4">Gestión de Referencias - {agentName}</h2>

            {agentId && (
                // evitamos problemas de duplicidades de Form con <> (un form dentro de otro form => error en react)
                <>
                    {loading ? (
                        <div className="text-center my-5">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Cargando...</span>
                            </Spinner>
                        </div>
                    ) : references.length > 0 ? (
                        <MiDataTable
                            key={tableKey}
                            id="references-table"
                            data={references}
                            columnas={columns}
                            columnactions="Acciones"
                            handleEditReg={handleEdit}
                            handleDeleteItem={handleDelete}
                            formulario={{ id: '' }}
                            linkColumns={[]}
                            traduction={{
                                sprocessing: { title: "Procesando..." },
                                slengthmenu: { title: "Mostrar _MENU_ registros" },
                                szerorecords: { title: "No se encontraron resultados" },
                                semptytable: { title: "Ningún dato disponible en esta tabla" },
                                sinfo: { title: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros" },
                                sinfoempty: { title: "Mostrando registros del 0 al 0 de un total de 0 registros" },
                                sinfofiltered: { title: "(filtrado de un total de _MAX_ registros)" },
                                sinfopostfix: { title: "" },
                                ssearch: { title: "Buscar:" },
                                surl: { title: "" },
                                sinfothousands: { title: "," },
                                sloadingrecords: { title: "Cargando..." },
                                sfirst: { title: "Primero" },
                                slast: { title: "Último" },
                                snext: { title: "Siguiente" },
                                sprevious: { title: "Anterior" },
                                ssortascending: { title: ": Activar para ordenar la columna de manera ascendente" },
                                ssortdescending: { title: ": Activar para ordenar la columna de manera descendente" },
                                rows: { title: '%d filas seleccionadas' },
                                copytitle: { title: 'Copiar al portapapeles' },
                                copykeys: { title: 'Use Ctrf+C para copiar los datos de la tabla a su portapapeles.' },
                                copysuccess: {
                                    many: { title: 'Copiadas %d filas al portapapeles' },
                                    one: { title: 'Copiada 1 fila al portapapeles' }
                                },
                            }}
                            paging={true}
                            searching={true}
                            ordering={true}
                            pagelength="5"
                        />
                    ) : (
                        <div className="alert alert-info">
                            No hay referencias registradas para este agente.
                        </div>
                    )}

                    {/* Formulario de Edición / Creación */}
                    {estadoForm === 'edit' && (
                        <div className="mt-4 p-3 border rounded bg-light">
                            <h5 className="mb-3">Editar Referencia</h5>
                            <>
                                <Row className="mb-3">
                                    <Col md={3} className="position-relative">
                                        <Form.Group>
                                            <Form.Label>Referencia</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="refpro"
                                                value={refSearchTerm}
                                                onChange={handleRefSearchChange}
                                                onFocus={() => refSearchTerm.trim() && setShowRefSuggestions(true)}
                                                onBlur={() => setTimeout(() => setShowRefSuggestions(false), 200)}
                                                autoComplete="off"
                                                required
                                            />
                                            {showRefSuggestions && refSearchTerm.trim() && (
                                                <ListGroup style={{ position: 'absolute', zIndex: 1000, width: '100%' }}>
                                                    {isRefLoading && refPage === 1 ? (
                                                        <ListGroup.Item className="text-center">
                                                            <Spinner animation="border" size="sm" /> Cargando...
                                                        </ListGroup.Item>
                                                    ) : supplierRefs.length > 0 ? (
                                                        <>
                                                            {supplierRefs.map((ref) => (
                                                                <ListGroup.Item key={ref.id} action onClick={() => handleSelectRef(ref)}>
                                                                    {ref.cod}
                                                                </ListGroup.Item>
                                                            ))}
                                                            {refPage < totalRefPages && (
                                                                <ListGroup.Item action onClick={() => fetchReferencesForAgent(agentId, refPage + 1, refSearchTerm)} className="text-center">
                                                                    {isRefLoading ? <Spinner animation="border" size="sm" /> : 'Cargar más'}
                                                                </ListGroup.Item>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <ListGroup.Item disabled>No se encontraron referencias</ListGroup.Item>
                                                    )}
                                                </ListGroup>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Descripción</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="des"
                                                value={formularioPrin.des || ''}
                                                onChange={(e) => handleInputForm(e, formularioPrin, saveFormularioPrin)}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={5} className="position-relative">
                                        <Form.Group>
                                            <Form.Label>Artículo Asociado</Form.Label>
                                            {isSearchingArticle || !formularioPrin.idart ? (
                                                <>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Escribe para buscar un artículo..."
                                                        value={articleSearchTerm}
                                                        onChange={handleArticleSearchChange}
                                                        autoComplete="off"
                                                        autoFocus
                                                    />
                                                    {showArticleSuggestions && articleSearchTerm && (
                                                        <ListGroup className="position-absolute w-100" style={{ zIndex: 1000, maxHeight: '250px', overflowY: 'auto' }}>
                                                            {articleSuggestions.map(article => (
                                                                <ListGroup.Item
                                                                    key={article.id}
                                                                    action
                                                                    onClick={() => handleSelectArticle(article)}
                                                                    dangerouslySetInnerHTML={{ __html: article.unidad }}
                                                                />
                                                            ))}
                                                            {isArticleLoading && (
                                                                <ListGroup.Item className="text-center">
                                                                    <Spinner animation="border" size="sm" />
                                                                </ListGroup.Item>
                                                            )}
                                                            {!isArticleLoading && articlePage < totalArticlePages && (
                                                                <ListGroup.Item action onClick={() => fetchArticles(articleSearchTerm, articlePage + 1)} className="text-center text-primary">
                                                                    Cargar más resultados...
                                                                </ListGroup.Item>
                                                            )}
                                                        </ListGroup>
                                                    )}
                                                </>
                                            ) : (
                                                <InputGroup>
                                                    <Form.Control
                                                        value={articleSearchTerm}
                                                        readOnly
                                                    />
                                                    <Button variant="outline-secondary" onClick={() => {
                                                        setIsSearchingArticle(true);
                                                        setArticleSearchTerm('');
                                                        saveFormularioPrin(prev => ({ ...prev, idart: null, nomart: '' }));
                                                    }}>
                                                        Cambiar
                                                    </Button>
                                                </InputGroup>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Button variant="success" type="button" onClick={handleSave} className="me-2">
                                    <i className="fas fa-save me-1"></i> Guardar
                                </Button>
                                <Button variant="secondary" onClick={handleCancelEdit}>
                                    Cancelar
                                </Button>
                            </>
                        </div>
                    )}
                </>
            )}
        </Container>
    );
}

export default References;